/* @flow */

export function getExtensionId(): string {
	return chrome.runtime.id;
}



// WEBPACK FOOTER //
// ./lib/environment/foreground/id.js